<template>
    <div class="home">
        <div class="banner">
            <img class="bg" src="@/assets/home/banner.jpg"/>
            <img class="bg-text" src="@/assets/home/banner-text.png"/>
            <div class="banner-text">
                <span class="item">Powered by advanced AI and cloud computing, BuildEffi AI<br/> revolutionizes cost estimation and design optimization, enabling<br/> smarter, faster, and greener construction.</span>
            </div>
        </div>
        <div class="message">
            <div class="info">
                <div class="title">Who We Are</div>
                <div class="note">At BuildEffi AI, we redefine construction by combining the limitless power of artificial intelligence and cloud technology. Our platform enables architects, engineers, and contractors to automate workflows, predict costs, and optimize designs with unparalleled precision and efficiency.</div>
                <div class="mark">Our platform is entirely AI-driven and cloud-based, ensuring real-time updates, secure data access, and scalability for projects of any size or complexity.</div>
            </div>
            <img class="interposition" src="@/assets/home/home-user.png"/>
        </div>
        <div class="ai">
            <div class="title">WHY BUILDEFFI AI</div>
            <div class="info">
                <div class="item">
                    <img src="@/assets/home/ai-item-1.png"/>
                    <div class="msg">AI-Powered Insights</div>
                    <div class="note">Make smarter, faster decisions with machine learning algorithms that analyze, predict, and optimize every detail.</div>
                </div>
                <div class="item">
                    <img src="@/assets/home/ai-item-2.png"/>
                    <div class="msg">Cloud-Enabled Access</div>
                    <div class="note">Collaborate effortlessly with a secure, real-time platform accessible from anywhere, on any device.</div>
                </div>
                <div class="item">
                    <img src="@/assets/home/ai-item-3.png"/>
                    <div class="msg">Unparalleled Efficiency</div>
                    <div class="note">Automate repetitive tasks, streamline complex workflows, and reduce errors at every stage.</div>
                </div>
                <div class="item">
                    <img src="@/assets/home/ai-item-4.png"/>
                    <div class="msg">Sustainability Through AI</div>
                    <div class="note">Use predictive analytics to create eco-friendly designs that align with modern environmental goals.</div>
                </div>
            </div>
        </div>
        <div class="work">
            <div class="title">HOW IT WORKS?</div>
            <div class="subtitle">BuildEffi AI operates at the intersection of AI and cloud computing, delivering seamless integration and unmatched accuracy</div>
            <div class="progress">
                <div class="left">
                    <img src="@/assets/home/circle.png"/>
                    <div class="bar"/>
                    <img src="@/assets/home/circle.png"/>
                    <div class="bar"/>
                    <img src="@/assets/home/circle.png"/>
                    <div class="bar"/>
                    <img src="@/assets/home/circle.png"/>
                    <div class="bar"/>
                    <img src="@/assets/home/circle.png"/>
                    <div class="bar"/>
                </div>
                <div class="right">
                    <div class="item">
                        <img src="@/assets/home/work-item-1.png"/>
                        <div class="title">Data Integration on the Cloud</div>
                        <div class="note">Upload project details, designs, and historical data directly to our secure cloud platform for centralized access.</div>
                    </div>
                    <div class="item">
                        <img src="@/assets/home/work-item-2.png"/>
                        <div class="title">AI-Powered Analysis</div>
                        <div class="note">Our machine learning algorithms analyze patterns, identify risks, and predict costs based on historical and real-time data.</div>
                    </div>
                    <div class="item">
                        <img src="@/assets/home/work-item-3.png"/>
                        <div class="title">Design and Cost Optimization</div>
                        <div class="note">Leverage AI to recommend design modifications, material efficiencies, and resource allocations to maximize outcomes.</div>
                    </div>
                    <div class="item">
                        <img src="@/assets/home/work-item-4.png"/>
                        <div class="title">Real-Time Collaboration</div>
                        <div class="note">With cloud accessibility, all stakeholders can view updates, share insights, and make decisions instantly from anywhere.</div>
                    </div>
                    <div class="item">
                        <img src="@/assets/home/work-item-5.png"/>
                        <div class="title">Dynamic Adjustments</div>
                        <div class="note">As project parameters evolve, AI recalculates and updates cost estimates and design suggestions in real time.</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="solutions">
            <div class="title">SOLUTIONS</div>
            <div class="info">
                <div class="item">
                    <img src="@/assets/home/solutions-item-1.png"/>
                    <div class="msg">
                        <div class="title">AI-Powered Cost Estimation</div>
                        <div class="note"><span>Real-Time Budgeting</span>: Powered by AI, our platform continuously updates cost models to reflect market changes and project variables.</div>
                        <div class="note"><span>Accurate Forecasting</span>: Eliminate budget overruns with precise, AI-driven predictions.</div>
                        <div class="note"><span>Resource Optimization</span>: Optimize material usage and labor allocation with machine learning insights.</div>
                    </div>
                </div>
                <div class="item">
                    <img src="@/assets/home/solutions-item-2.png"/>
                    <div class="msg">
                        <div class="title">Cloud-Based Design Optimization</div>
                        <div class="note"><span>Structural Integrity</span>: AI evaluates and improves safety and compliance in real-time.</div>
                        <div class="note"><span>Eco-Friendly Designs</span>: AI suggests sustainable options with minimal environmental impact.</div>
                        <div class="note"><span>Seamless Collaboration</span>: Team members can access and modify designs via the cloud platform, ensuring everyone stays aligned.</div>
                    </div>
                </div>
                <div class="item">
                    <img src="@/assets/home/solutions-item-3.png"/>
                    <div class="msg">
                        <div class="title">Lifecycle Management with AI Insights</div>
                        <div class="note"><span>Predictive Risk Detection</span>: AI identifies and mitigates risks before they escalate.</div>
                        <div class="note"><span>Timeline Optimization</span>: Dynamic scheduling powered by AI ensures projects stay on track.</div>
                        <div class="note"><span>Continuous Improvement</span>: Real-time feedback and insights allow for constant refinement throughout the project lifecycle.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data: () => ({

    })
}
</script>

<style scoped lang="scss">
.banner {
    position: relative;
    width: 100%;

    .bg {
        width: 100%;
    }

    .bg-text {
        position: absolute;
        top: 203px;
        left: 92px;
        height: 172px;
        object-fit: contain;
    }

    .banner-text {
        position: absolute;
        top: 413px;
        left: 96px;
        .item {
            font-size: 16px;
            line-height: 30px;
            color: #ffffff;
            text-transform: capitalize;
        }
    }
}

.message {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    position: relative;
    width: 100%;
    height: 720px;
    padding: 177px 154px 0 140px;
    background: url("../assets/home/user-bg.png") no-repeat 100%;

    .interposition {
        position: absolute;
        top: 115px;
        left: 140px;
        width: 696px;
        object-fit: contain;
        z-index: 1;
    }

    .info {
        width: 558px;
        z-index: 2;

        .title {
            font-size: 40px;
            font-weight: 700;
            line-height: 73px;
            color: #ffffff;
            letter-spacing: 1px;
            margin-bottom: 17px;
        }

        .note,
        .mark {
            width: 100%;
            font-size: 16px;
            font-weight: 400;
            line-height: 30px;
            color: #ffffff;
            text-transform: capitalize;
        }

        .mark {
            width: 515px;
            margin-top: 32px;
        }
    }
}

.ai {
    width: 100%;
    height: 767px;
    padding-top: 82px;

    .title {
        width: 100%;
        font-size: 40px;
        font-weight: 700;
        color: #ffffff;
        line-height: 73px;
        text-align: center;
        margin-bottom: 100px;
    }

    .info {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: 0 160px;

        .item {
            flex: none;
            width: 232px;
            text-align: center;
            text-transform: capitalize;

            > img {
                width: 188px;
                height: 188px;
                object-fit: contain;
                margin-bottom: 11px;
            }

            .msg {
                font-size: 16px;
                font-weight: 700;
                color: #ffffff;
                line-height: 30px;
                margin-bottom: 24px;
            }

            .note {
                font-size: 14px;
                font-weight: 400;
                color: #ffffff;
                line-height: 26px;
            }
        }
    }
}

.work {
    width: 100%;
    height: 1587px;
    padding-top: 82px;
    text-align: center;
    background: url("../assets/home/work.jpg") no-repeat 100%;

    > .title {
        width: 100%;
        font-size: 40px;
        font-weight: 700;
        color: #ffffff;
        line-height: 73px;
        text-align: center;
        margin-bottom: 25px;
    }
    .subtitle {
        display: inline-flex;
        width: 882px;
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
        line-height: 30px;
        margin-bottom: 64px;
        text-transform: capitalize;
    }

    .progress {
        display: flex;
        width: 100%;
        padding-left: 400px;

        .left {
            display: flex;
            align-items: center;
            flex-direction: column;
            width: 40px;

            > img {
                width: 40px;
                height: 40px;
                margin-bottom: 16px;
            }

            .bar {
                width: 0;
                height: 160px;
                border: 3px solid #2a2942;
                border-radius: 3px;
                margin-bottom: 16px;

                &:last-child {
                    border-color: #3E79F4;
                    margin-bottom: 0;
                }
            }
        }

        .right {
            padding-left: 52px;
            .item {
                width: 551px;
                height: 232px;
                padding-top: 30px;
                text-align: left;

                > img {
                    width: 50px;
                    height: 50px;
                    object-fit: contain;
                    margin-bottom: 20px;
                }

                .title {
                    font-size: 20px;
                    font-weight: 700;
                    line-height: 36px;
                    color: #ffffff;
                    margin-bottom: 8px;
                }

                .note {
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 26px;
                    color: #ffffff;
                    text-transform: capitalize;
                }
            }
        }
    }
}

.solutions {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 100%;
    height: 1647px;
    padding-top: 72px;
    background: url("../assets/home/solutions.jpg") no-repeat 100%;

    > .title {
        width: 100%;
        font-size: 40px;
        font-weight: 700;
        color: #ffffff;
        line-height: 73px;
        text-align: center;
        margin-bottom: 50px;
    }

    .info {
        display: inline-flex;
        flex-direction: column;
        width: 1180px;

        .item {
            display: flex;
            width: 100%;
            height: 386px;
            padding: 40px;
            margin-bottom: 48px;
            border-radius: 20px;
            background-color: rgba(10, 12, 53, 0.9);
            box-shadow: 0 0 12px 4px #0f2a6f;

            &:last-child {
                margin-bottom: 0;
            }

            > img {
                width: 460px;
                height: 306px;
                object-fit: contain;
                margin-right: 58px;
            }

            .msg {
                padding-top: 16px;

                .title {
                    font-size: 20px;
                    font-weight: 700;
                    line-height: 36px;
                    color: #ffffff;
                    margin-bottom: 24px;
                }

                .note {
                    position: relative;
                    padding-left: 24px;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 30px;
                    color: #ffffff;
                    margin-bottom: 20px;
                    text-transform: capitalize;

                    &::after {
                        content: "";
                        position: absolute;
                        top: 11px;
                        left: 0;
                        width: 8px;
                        height: 8px;
                        background-color: #5adbf8;
                        border-radius: 50%;
                    }

                    &:last-child {
                        margin-bottom: 0;
                    }

                    > span {
                        color: #5adbf8;
                    }
                }
            }
        }
    }
}
</style>
